import React from 'react';
import { MdOutlineToday } from "react-icons/md";
import { NavLink } from 'react-router-dom';
import { IoCalendarSharp } from "react-icons/io5";
import { BiCalendarStar } from "react-icons/bi";import { FaUsers } from "react-icons/fa";
import './layout.css';

const BradFactorLayouts = ({ children }) => {
  return (
    <div className='container-fluid'>
      <h1 className="layouts-title">
        <BiCalendarStar className="layouts-icon" />
      Previous Month BradFord Factor Scores
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="bradfactor-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/bradfactor"
              >
                <MdOutlineToday className="nav-icon" /> Previous Month
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="bradford-factor-by-month-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/view-bradford"
              >
                <IoCalendarSharp  className="nav-icon" /> View BradFord Factor by Month
              </NavLink>
            </li>
            
            <li className="nav-item">
              <NavLink
                id="all-emps-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/all-employee"
              >
                <FaUsers className="nav-icon" /> All Employees
              </NavLink>
            </li>
           
          </ul>
        </div>
        <div className="content">
          {children} {/* Render the child components here */}
        </div>
      </section>
    </div>
  );
};

export default BradFactorLayouts;
